import React, { useState, useEffect } from "react";
import { Button, Modal, Card, Form, Row, Col } from "react-bootstrap";
import { useSelector } from "react-redux";
import PaymentDetails from "../AddStudent/paymentDetailsComponent";
import { PAYMENT_FOR_DRESS } from "../../constants";

const PayForDress = (props) => {
  const { data, closeModal, payForDressShow, setPayForDressShow } = props;
  const { classRoomsList } = useSelector((state) => state.student);
  const [show, setShow] = useState(props.show);
  useEffect(() => {
    setShow(props.show);
  }, [props.show]);

  const handleClose = () => {
    setShow(false);
    closeModal();
  };
  const handleShow = () => setShow(true);
  return (
    <>
      <Modal show={payForDressShow} size="xl" onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Pay for </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Card>
            <Card.Header> Pay </Card.Header>
            <Card.Body>
              <PaymentDetails
                payFrom={PAYMENT_FOR_DRESS}
                payData={data}
                payForDressShow={payForDressShow}
                setPayForDressShow={setPayForDressShow}
              />
            </Card.Body>
          </Card>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          {/* <Button variant="primary" type="submit">
            Save Changes
          </Button> */}
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default PayForDress;
